<template>
  <!-- Element Plus 全局通知由 watch 触发，无需渲染实体 DOM -->
  <div class="sr-only" aria-hidden="true"></div>
</template>

<script>
import { watch } from 'vue'
import { useNotificationStore } from '@/stores/notification'
import { storeToRefs } from 'pinia'
import { ElNotification } from 'element-plus'

export default {
  name: 'NotificationContainer',
  setup() {
    const notificationStore = useNotificationStore()
    const { notifications } = storeToRefs(notificationStore)

    // 当 store 中的通知标记为 show 时，使用 Element Plus 弹出通知
    watch(
      notifications,
      (list) => {
        list.forEach((item) => {
          if (item.show && !item._dispatched) {
            ElNotification({
              title: item.type === 'success' ? '成功' : item.type === 'error' ? '错误' : '提示',
              message: item.message,
              type: item.type,
              duration: 2500,
              offset: 60
            })
            // 防重复
            item._dispatched = true
          }
        })
      },
      { deep: true }
    )

    return {
      notifications
    }
  }
}
</script>
